// extracted by mini-css-extract-plugin
export default {"header":"Header_header__mtodi","gurgaonMap":"Header_gurgaonMap__lBYsS","a":"Header_a__m5X9B","headerText":"Header_headerText__tJr7w"};